import { render, staticRenderFns } from "./FixedPointsList.vue?vue&type=template&id=40c65b44&scoped=true"
import script from "./FixedPointsList.vue?vue&type=script&lang=js"
export * from "./FixedPointsList.vue?vue&type=script&lang=js"
import style0 from "./FixedPointsList.vue?vue&type=style&index=0&id=40c65b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c65b44",
  null
  
)

export default component.exports